import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {useLocation} from "react-router-dom";

export function PrintView() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const job = useLocation().state

    const onButtonClick = () => {
        // using Java Script method to get PDF file
        const numberFiles = job.printFiles.length

        for (const file in job.printFiles) {
            fetch(job.printFiles[file].file).then(response => {
                response.blob().then(blob => {
                    const fileURL = window.URL.createObjectURL(blob);
                    let alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download = job.printFiles[file].name;
                    alink.click();
                })
            })
        }
    }

    function printFileNames() {
        const returnList = [];

        for (const file in job.printFiles) {
            returnList.push(
                <div>
                    <p> {job.printFiles[file].name} </p>
                </div>
            )
        }
        return returnList
    }

    function showCompleted() {
        if (job.printingStatus === "COMPLETE") {
            return (
                <div>
                    <div className="list-section">
                        <p>Printing completed: {job.dates.printFilesCompleted}</p>
                        <p>Printed by: [employee name]</p>
                    </div>
                    <div className="page-break"></div>
                </div>
            )
        }
    }

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>Printing information for {job.name}</h1>
                    <p>Job ID: #{job.id}</p>
                </div>
                <hr/>

                <div className="page-break"></div>

                <div className="list-section">
                    <h3> Print Files </h3>
                    <hr/>
                    <br/>
                    {printFileNames()}
                    <button className="btn btn-secondary" onClick={onButtonClick}>
                        Download print files
                    </button>

                </div>

                <div className="page-break"></div>

                <div>
                    {showCompleted()}
                </div>
            </AuthenticatedTemplate>
        </div>
    );
}
